import { URLParameters } from '@/app/common/urlParameters.ts';
import { type Option, ControlType } from '../../../Form';
import { parseAddLabel } from '../utils';

type GetListboxContainer = {
  fieldName: string;
  containerTitle: string;
  containerName: string;
  label: string | undefined;
  options: Option[];
  value: (number | string)[];
  clearAll: string;
  hide?: boolean;
  isMobile?: boolean;
  isSidebar?: boolean;
  isHorizontal?: boolean;
  isWaiting: boolean;
  noResultsText?: string;
  anyField?: string;
};

export const sortList = (a: Option, b: Option) => {
  if (!a.label || !b.label) return 0;

  if (a.label < b.label) {
    return -1;
  }
  if (a.label > b.label) {
    return 1;
  }
  return 0;
};

const getSearchListContainer = (params: GetListboxContainer) => {
  const {
    fieldName,
    containerName,
    containerTitle,
    options,
    value,
    clearAll,
    hide,
    isMobile,
    isSidebar,
    isHorizontal,
    label,
    noResultsText,
    anyField,
    isWaiting,
  } = params;

  const parsedOptions = options
    .map((option) => ({
      ...option,
      ...(option.addLabel
        ? { addLabel: parseAddLabel({ withBrackets: !isMobile && !isSidebar, count: option.addLabel }) }
        : {}),
      ...((option.addLabel && option.addLabel === '0') || isWaiting ? { disabled: true } : {}),
    }))
    .sort(sortList);

  return {
    control: ControlType.CONTAINER,
    name: containerName,
    top: { text: containerTitle },
    controls: [
      {
        control: ControlType.SEARCH_LIST,
        name: fieldName,
        label,
        options:
          (fieldName === URLParameters.ACCOMODATION_STATION ||
            fieldName === URLParameters.ACCOMODATION_BEACH ||
            fieldName === URLParameters.ACCOMODATION_SKILIFT) &&
          anyField !== ''
            ? [
                { ...parsedOptions.filter((x) => x.value === '0')[0], unselectOther: true, label: anyField },
                ...parsedOptions.filter((x) => x.value !== '0'),
              ]
            : parsedOptions,
        value,
        default: [],
        ...(!isMobile && !isSidebar && !isHorizontal ? { columns: 2, limit: 10 } : { limit: 5 }),
        noResultsText,
      },
    ],
    controlProps: {
      clearAll,
    },
    hide,
  };
};

export default getSearchListContainer;
